export default {
    i18n: {
        "day": "dag",
        "Device Information": "Apparaat informatie",
        "handset": "Hoorn",
        "bluetooth": "Bluetooth",
        "Access Denied.": "Toegang geweigerd.",
        "Fingerprint": "Vingerafdruk",
        "Date Time": "Datum Tijd",
        "name": "Naam",
        "tamperAlarm": "Sabotage alarm",
        "Http": "HTTP",
        "Device Name": "Toestelnaam",
        "auto": "Auto",
        "Group": "Groep",
        "Volume": "Geluiden",
        "Card": "Kaart",
        "minutes": "Minuten",
        "timezone": "tijdzone",
        "Are you sure you want to delete this device?": "Weet je zeker dat je dit apparaat wilt verwijderen?",
        "Attendance Point Name": "Aanwezigheidspunt",
        "Mac": "Mac",
        "confirmToDeleteIt?": "Bevestig het verwijderen?",
        "captureLogs": "Foto logs ",
        "Doors": "Deuren",
        "All Doors": "Alle deuren",
        "Lock List": "Lijst met vergrendelingen",
        "Link Device Relay": "Apparaatrelais koppelen",
        "Added Successfully!": "Succesvol toegevoegd!",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "Wanneer het slot is gekoppeld aan een relais, wordt het slot ontgrendeld wanneer het relais wordt geactiveerd.",
        "Adding...": "Voegt toe…",
        "Please try again 24 hours later.": "Probeer het 24 uur later opnieuw.",
        "Action": "Actie",
        "Address": "Adres",
        "Owner": "Eigenaar",
        "Failed": "Mislukt",
        "Timeout": "Time-out",
        "Response": "Resultaat",
        "caller": "Beller",
        "receiver": "Ontvanger",
        "doorLogs": "Deur logs",
        "callHistory": "Oproeplijst",
        "UID": "UID",
        "Call Type": "Oproep type",
        "Code": "Code",
        "User": "Gebruiker",
        "Device List": "Toestel lijst",
        "Model": "Model",
        "Time": "Tijd",
        "Company": "Bedrijf",
        "Property Managers": "Vastgoedbeheerders",
        "Current Version": "Huidige versie",
        "indoorMonitor": "Binnenmonitor",
        "guardPhone": "Bewaker binnenpost",
        "close": "Dichtbij",
        "Success": "Succes",
        "URL": "URL",
        "Please select a device.": "Selecteer een apparaat.",
        "Password is too weak.": "Wachtwoord is te zwak.",
        "Company is required.": "Voer de bedrijfsnaam in.",
        "Your account is not activated, please contact your service provider.": "Uw account is niet geactiveerd, neem contact op met uw serviceprovider.",
        "Language": "Taal",
        "Face": "Gezicht",
        "Please set at least one access type.": "Stel minstens één toegangstype in.",
        "Please contact your service provider to activate this advanced feature.": "Neem contact op met uw serviceprovider om deze geavanceerde functie te activeren.",
        "Community name": "Gemeenschapsnaam",
        "Please enable PM App first.": "Schakel PM App eerst in.",
        "Username": "Gebruikersnaam",
        "Change Log": "Log wijzigen",
        "Assign": "Toewijzen",
        "Floor": "Verdieping",
        "Link Device": "Koppel apparaat",
        "Accessible Floors": "Toegankelijke verdiepingen",
        "Upgrade": "Service",
        "Function": "Functie",
        "callDuration": "Gespreks duur",
        "No": "Nee",
        "Verification Code": "Verificatiecode",
        "Expiration Time": "Vervaltijd",
        "PIN": "PIN",
        "MAC": "MAC",
        "Building": "Gebouw",
        "APT": "APT",
        "ID": "ID",
        "Name": "Naam",
        "activities": "Activiteiten",
        "Obtain": "Verkrijgen",
        "call": "Opbellen",
        "Group Call": "Groepsoproep",
        "Delete": "Wissen",
        "Yes": "Ja",
        "Door Release PIN": "Deur ontgrendel pincode",
        "Email": "E-mail",
        "Mobile Number doesn\'t exist.": "Mobiel nummer bestaat niet",
        "Tips": "Tips",
        "Password": "Wachtwoord",
        "The end time cannot be earlier than the start time.": "De eindtijd kan niet eerder zijn dan de begintijd.",
        "Back": "Terug",
        "File format error.": "Fout in bestandsindeling.",
        "motionDetection": "Bewegingsdetectie",
        "You are trying too often, please try again in 5 minutes": "U probeert het te vaak, probeer het opnieuw in vijf minuten",
        "User name too long.": "Gebruikersnaam te lang.",
        "This MAC address is redirected on RPS.": "Dit MAC adres wordt omgeleid op RPS.",
        "No Answer": "Geen antwoord",
        "failedToUnlock": "Ontgrendelen mislukte",
        "visitor": "bezoeker",
        "yesterday": "Gisteren",
        "Too large data! Please first export the data before %s first,thanks.": "Te grote data! Exporteer eerst de gegevens vóór%s, bedankt.",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "Controleer of er onbetaalde bestellingen zijn, zo niet, neem dan contact op met uw serviceprovider",
        "lock": "Deur sluiten",
        "open": "Open",
        "The PersonalAccount is not active.": "De persoonlijke account is niet actief.",
        "You cannot link an account that already link other accounts.": "U kunt geen account koppelen dat al andere accounts koppelt.",
        "You cannot link multiple property manager accounts under the same installer account.": "U kunt niet meerdere accounts voor property manager koppelen onder hetzelfde installatieaccount.",
        "You cannot link to the currently logged in account.": "U kunt geen koppeling maken met het momenteel ingelogde account.",
        "nfc": "NFC",
        "Delete Device": "Apparaat verwijderen",
        "date": "Datum",
        "Device deleted successfully": "Apparaat met succes verwijderd",
        "Failed to delete device": "Verwijderen van apparaat mislukt",
        "Are you sure you want to cancel?": "Weet u zeker dat u wilt annuleren?",
        "Unlimited": "Onbeperkt",
        "Battery Level": "Batterijniveau",
        "Password Incorrect.": "Wachtwoord onjuist.",
        "deliverySystemVerification": "Verificatie van het leveringssysteem",
        "None": "Geen",
        "unlock": "Open",
        "Upgrading...": "Verbetering...",
        "amenityReservation": "Ameniteitsreservering",
        "idAccess": "ID toegang",
        "RF Card": "RF-kaart",
        "exitButton": "Deuropenknop",
        "Please select at least one item.": "Selecteer ten minste één item.",
        "The ID can contain only digits and letters, up to 32 characters.": "De ID kan alleen cijfers en letters bevatten, tot 32-tekens.",
        "The PIN is not available.": "De pincode is niet beschikbaar.",
        "Change WiFi": "WiFi wijzigen",
        "Phone number": "Telefoonnummer",
        "Invalid {0}.": "Ongeldig {0}.",
        "{0} already exists.": "{0} bestaat al.",
        "Operation failed!": "Operatie mislukt!",
        "Failed to get data.": "Kon gegevens niet ophalen.",
        "You do not have the necessary permissions to perform this operation.": "U beschikt niet over de benodigde machtigingen om deze bewerking uit te voeren.",
        "You can only import one template at a time in the current site.": "U kunt slechts één sjabloon tegelijk importeren in de huidige site.",
        "Delivery name": "Leveringsnaam",
        "MAC address not in the MAC library.": "MAC adres niet in de MAC bibliotheek.",
        "Please delete devices under this building.": "Verwijder apparaten onder dit gebouw.",
        "The start time cannot be later than the end time.": "De starttijd mag niet later zijn dan de eindtijd.",
        "emergency action type": "type noodactie",
        "Only 1000 data items can be imported at a time.": "Er kunnen slechts 1000-gegevensitems tegelijk worden geïmporteerd.",
        "The password is too short.": "Het wachtwoord is te kort.",
        "The data has been updated. Please refresh the page and try again.": "De gegevens zijn bijgewerkt. Vernieuw de pagina en probeer het opnieuw.",
        "AutoP length must be less 2048 bytes.": "AutoP-lengte moet minder 2048 bytes zijn.",
        "File Check Failed": "Bestandscontrole mislukt",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "Login voor beheerdersaccount is verlopen. Neem contact op met uw serviceprovider.",
        "iqPinVerificationFailed": "IQ PIN verificatie mislukt.",
        "accountBlacklisted": "Account op de zwarte lijst.",
        "outsideAuthorizedTime": "Buiten de toegestane tijd.",
        "network group": "netwerkgroep",
        "Company name": "Bedrijfsnaam",
        "Group name": "Groepsnaam",
        "relay": "relais",
        "motionTime": "bewegingTime",
        "motionType": "bewegingstype",
        "postalCode": "postcode",
        "floor format": "vloerformaat",
        "mobilePhone": "mobiele telefoon",
        "time format": "tijdsindeling",
        "security relay": "veiligheidsrelais",
        "Param": "Param",
        "Offline Code": "Offline code",
        "Add akubela Smart Locks": "Slimme Akubela sloten toevoegen",
        "Module Version": "Moduleversie",
        "Lock Body Version": "Body-versie vergrendelen",
        "Available Version": "Beschikbare versie",
        "Please wake up the lock screen and then upgrade.": "Maak het vergrendelingsscherm wakker en upgrade.",
        "This process will take some time, please be patient.": "Dit proces zal enige tijd duren, wees geduldig.",
        "Please confirm that the WiFi network is functioning properly.": "Controleer of het WiFi-netwerk goed functioneert.",
        "Please wake up the lock screen.": "Maak alsjeblieft het vergrendelingsscherm wakker.",
        "This lock has already been added to another apartment.": "Dit slot is al toegevoegd aan een ander appartement.",
        "This lock has already been added to the apartment.": "Dit slot is al toegevoegd aan het appartement.",
        "Pin Code": "Pin code",
        "Too many failed attempts, please try again in a few minutes.": "Te veel mislukte pogingen, probeer het opnieuw in een paar minuten.",
        "Login Account": "Inloggen account",
        "Same account cannot login in different ins.": "Dezelfde account kan niet inloggen in verschillende ins.",
        "Lock Name": "Naam vergrendelen",
        "Smart Locks": "Slimme sloten",
        "Add Smart Lock": "Slim slot toevoegen",
        "The selected duration cannot be more than one year.": "De geselecteerde duur mag niet langer zijn dan een jaar.",
        "The end time of the break time cannot be later than the end work time.": "De eindtijd van de pauzetijd mag niet later zijn dan de eindtijd van het werk.",
        "The start time of the break time cannot be earlier than the start work time.": "De starttijd van de pauze mag niet eerder zijn dan de starttijd van het werk.",
        "The end time of the valid check time cannot be earlier than the end work time.": "De eindtijd van de geldige controletijd mag niet eerder zijn dan de eindtijd van het werk.",
        "The start time of the valid check time cannot be later than the start work time.": "De starttijd van de geldige controle mag niet later zijn dan de starttijd van het werk.",
        "Deleting failed. The timetable is used by a shift.": "Verwijderen mislukt. Het rooster wordt gebruikt door een dienst.",
        "Deleting failed. The shift is in use.": "Verwijderen mislukt. De dienst is in gebruik.",
        "Deleting failed. The leave type is in use.": "Verwijderen mislukt. Het verloftype is in gebruik.",
        "Valid time conflicts with an existing schedule.": "Geldige tijd conflicteert met een bestaand schema.",
        "The timing for multiple schedules must not coincide.": "De timing voor meerdere schema\'s mag niet samenvallen.",
        "Attendance Log": "Aanwezigheidslogboek",
        "Added Failed!": "Voeg fouten toe!",
        "Setting WiFi": "Een draadloos netwerk instellen",
        "License Plate": "Kentekenplaat",
        "key": "Sleutel",
        "IQ Offline.": "IQ offline.",
        "{0}Unlock": "{0} Ontgrendelen",
        "automatically": "Automatisch",
        "manually": "Handmatig",
        "Video Storage": "videopslag",
        "Device(s) for Video Storage": "Appara(a)t(en) voor video-opslag",
        "The amount of exported data is too large. Please export it in batches.": "De hoeveelheid geëxporteerde gegevens is te groot. Exporteer deze in batches.",
        "Auto-record video when door unlocks": "Video automatisch opnemen bij ontgrendeling van de deur",
        "Auto-record video during calls": "Video automatisch opnemen tijdens oproepen",
        "Manual video recording in monitoring": "Handmatige video-opname tijdens monitoring",
        "Saved for 30days/60days/90days": "Bewaard voor 30/60/90 dagen",
        "To subscribe, please contact your provider for activation.": "Neem voor een abonnement contact op met uw provider om te activeren.",
        "Saved for {0}days": "Bewaard voor {0} dagen",
        "Subscribed Plan": "Geabonneerd plan",
        "Supported Devices: {0}": "Ondersteunde apparaten: {0}",
        "{0}Lock": "{0} Vergrendelen",
        "Video Saving": "Video-opslag",
        "Download Completed!": "Download voltooid!",
        "Fail to download.": "Downloaden mislukt.",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "Verwijderen mislukt! De vastgoedbeheerder is gekoppeld aan het RentManager-account. U dient dit account eerst te verwijderen.",
        "No log to be exported.": "Geen log te exporteren.",
        "capture&Video": "Schermafbeelding en video",
        "packageDetection": "Pakketdetectie",
        "Time format is invalid.": "Tijdnotatie is ongeldig.",
        "No permission to export logs of this type.": "Geen toestemming om logs van dit type te exporteren.",
        "Project type is invalid.": "Projecttype is ongeldig.",
        "Salto Account Blocked.": "Salto-account geblokkeerd.",
        "Remote open not in access group.": "Geen externe deuropening mogelijk buiten de toestemmingsgroep.",
        "SIP Account required.": "SIP-account vereist.",
        "The PIN must be {0} digits.": "De PIN moet {0} cijfers bevatten.",
        "gatewayConnectionUnavailable": "Gateway-verbinding niet beschikbaar.",
        "Invalid Username or Password": "Ongeldige gebruikersnaam of wachtwoord",
        "Account already linked to another user.": "Account al gekoppeld aan een andere gebruiker.",
        "The account has been added by another user.": "Het account is toegevoegd door een andere gebruiker.",
        "Failed to add. This user already has 5 license plates.": "Toevoegen mislukt, deze gebruiker heeft al 5 kentekenplaten",
        "Please at least select a door.": "Selecteer minimaal één deur.",
        "UHF Card": "UHF-kaart",
        "personnel": "personeel",
        "Parking Lot Name": "Naam parkeerplaats",
        "Controlled Relay": "Aangestuurd relais",
        "No Permission": "Geen toestemming",
        "Please ensure that all doors in the project are activated at the same time.": "Zorg ervoor dat alle deuren in het project tegelijkertijd worden geactiveerd.",
        "gatewayBusy": "Gateway is bezet",
        "Please set the perimeter door group first.": "Stel eerst de perimeterdeurgroep in.",
        "Please ensure that all doors in the project are renewed at the same time.": "Zorg ervoor dat alle deuren in het project tegelijkertijd worden vernieuwd.",
        "When lockdown is on, the controlled relay cannot be modified.": "Tijdens lockdown kan het relais niet worden aangepast.",
        "DetectionLogs": "Detectielogs",
        "packageIn": "Pakket in",
        "packageOut": "Pakket uit",
        "View Progress": "Voortgang bekijken",
        "Check if the WiFi is operating on the 2.4GHz band.": "Controleer of de wifi werkt op de 2,4 GHz-band.",
        "Verify that the WiFi password is correct.": "Controleer of het wifi-wachtwoord correct is.",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "Zorg ervoor dat u tijdens de hotspotconfiguratie verbonden bent met de juiste apparaat-hotspot.",
        "Offline Code Unlock": "Offline code ontgrendeling",
        "Salto Token Expired.": "Salto-token verlopen.",
        "Lock Offline": "Slot offline",
        "identity information! Please login again": "Identiteitsgegevens! Log opnieuw in.",
        "Email is required.": "E-mailadres is verplicht.",
        "Mobile number is required.": "Mobiel nummer is verplicht.",
        "You can\'t make payments for offices in different time zones.": "U kunt geen betalingen doen voor kantoren in verschillende tijdzones.",
        "The current scheduling staff exceeds 200 people.": "Het huidige personeelsrooster bevat meer dan 200 personen.",
        "param": "parameter",
        "Invalid UserName or Password": "Ongeldige gebruikersnaam of wachtwoord",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "Uw Salto KS-account heeft geen toestemming om de naam van het slot te wijzigen.",
        "Owner is required.": "Eigenaar is verplicht.",
        "Office is required.": "Kantoor is verplicht.",
        "PIN or RF Card is required.": "PIN of RF-kaart is verplicht.",
        "RF card": "RF-kaart",
        "Personnel is required.": "Personeel is verplicht.",
        "email address": "e-mailadres",
        "mobile number": "mobiel nummer",
        "The length must be less than 32 characters.": "Lengte moet kleiner zijn dan 32 tekens.",
        "The length must be less than 256 characters.": "Lengte moet kleiner zijn dan 256 tekens.",
        "Access Group is required.": "Toegangsrechten zijn verplicht.",
        "Device is required.": "Apparaat is verplicht.",
        "Admin is required.": "Beheerder is verplicht.",
        "Mobile number": "Mobiel nummer",
        "schedules": "roosters",
        "Timetable name": "Roosternaam",
        "Shift name": "Dienstnaam",
        "Leave type": "Soort verlof",
        "recheck in time": "Opnieuw inchecktijd",
        "recheck out time": "Opnieuw uitchecktijd",
        "The building name": "Gebouwnaam",
        "Building is required.": "Gebouw is verplicht.",
        "selection, The same reader cannot be set for both entry and exit": "selectie, Dezelfde lezer kan niet worden ingesteld voor zowel ingang als uitgang",
        "Door number": "Deurnummer",
        "door input cannot be selection duplicated.": "Deurinput kan niet dubbel geselecteerd worden.",
        "Group is required.": "Groep is verplicht.",
        "Title can contain up to 32 characters.": "Titel mag maximaal 32 tekens bevatten.",
        "Content can contain up to 1024 characters.": "Inhoud mag maximaal 1024 tekens bevatten.",
        "Content can contain up to 64 characters.": "Inhoud mag maximaal 64 tekens bevatten.",
        "Report is required.": "Rapport is verplicht.",
        "ID is required.": "ID is verplicht.",
        "The office does not exist.": "Het kantoor bestaat niet.",
        "Office name": "Kantoornaam",
        "The Temp Key does not exist.": "Tijdelijke sleutel bestaat niet.",
        "autolock time": "autolocktijd",
        "The User does not exist.": "De gebruiker bestaat niet.",
        "The Installer does not exist.": "De installateur bestaat niet.",
        "The Project does not exist.": "Het project bestaat niet.",
        "The Distributor does not exist.": "De distributeur bestaat niet.",
        "The Community Device does not exist.": "Gemeenschapsapparaat bestaat niet.",
        "The Property Manager does not exist.": "Gebouwbeheerder bestaat niet.",
        "The Sub Distributor does not exist.": "Subdistributeur bestaat niet.",
        "The Single Slave does not exist.": "Single Slave bestaat niet.",
        "The Property Manager EndUser does not exist.": "Gebouwbeheer eindgebruiker bestaat niet.",
        "The Family Member does not exist.": "Familielid bestaat niet.",
        "Set Failed!": "Instellen mislukt!",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "U heeft het maximum van 10 offline codes binnen 30 minuten bereikt, probeer het later opnieuw.",
        "This Email doesn\'t exist.": "E-mail bestaat niet.",
        "detection type": "detectietype",
        "Device UUID": "Apparaat UUID",
        "smart lock device": "slim slot",
        "You are trying too often, please try again in 5 minutes.": "Te vaak geprobeerd, probeer het over 5 minuten opnieuw.",
        "You can only import one file at a time. Please wait for the current import to finish.": "U kunt slechts één bestand tegelijk importeren. Wacht tot de huidige import is voltooid.",
        "NVR Name": "NVR-naam",
        "NVR Address": "NVR-adres",
        "Stay Alarm": "Verblijfsalarm",
        "Happended On": "Gebeurde op",
        "Edit Milesight NVR": "Milesight NVR bewerken",
        "Add Milesight NVR": "Milesight NVR toevoegen",
        "Auto-record video on motion detection, package detection": "Automatisch video opnemen bij bewegings- en pakketdetectie",
        "A 7-day free trial is included with your subscription.": "Uw abonnement bevat een gratis proefperiode van 7 dagen.",
        "For service renewal, please reach out to your provider.": "Neem contact op met uw provider voor vernieuwing van de dienst.",
        "Allow the Property Manager to view recorded videos": "Sta de gebouwbeheerder toe opgenomen video\'s te bekijken",
        "Please ensure the WiFi network is working properly.": "Zorg ervoor dat de WiFi goed werkt.",
        "Edit akubela Smart Locks": "akubela slimme sloten bewerken",
        "Upgraded Successfully!": "Upgrade geslaagd!",
        "Upgraded Failed!": "Upgrade mislukt!",
        "Editing...": "Bezig met bewerken...",
        "Edited successfully!": "Succesvol bewerkt!",
        "Edited Failed!": "Bewerken mislukt!",
        "Downloading video...": "Bezig met video downloaden...",
        "All Locks": "Alle sloten",
        "Select Locks": "Selecteer sloten",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "Zodra het akubela slot verbonden is met het netwerk, kan de PIN van {0} cijfers worden gebruikt. Let op: na synchronisatie kan het even duren voordat de PIN actief is.",
        "Please at least select a door or a lock.": "Kies minimaal een deur of slot.",
        "This lock has already been added to your apartment.": "Dit slot is al toegevoegd aan uw kamer.",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "Dit slot is al toegevoegd aan een andere kamer, neem contact op met uw provider voor hulp.",
        "LockBody Version": "Slotlichaamversie",
        "Two-factor Authentication": "Twee-factor authenticatie",
        "Monitoring Scope": "Monitorbereik",
        "Stay Duration": "Verblijfsduur",
        "Volume Settings": "Volumeregeling",
        "get card list for lock error": "Fout bij het ophalen van kaartlijst van slot",
        "get card list parse fail": "Fout bij het ontleden van kaartlijst",
        "get pin list for lock error": "Fout bij het ophalen van pincode-lijst van slot",
        "get pin list parse fail": "Fout bij het ontleden van pincode-lijst",
        "fingerprint code must be less than 2048 characters or empty.": "Vingerafdrukcode moet minder dan 2048 tekens bevatten of leeg zijn.",
        "Personnel not in office.": "Personeel is niet op kantoor.",
        "customize form fail.": "Aangepast formulier mislukt.",
        "smart lock type error.": "Slim slottype fout.",
        "invalid client id or secret": "Ongeldige client-ID of secret",
        "invalid account or password": "Ongeldig account of wachtwoord",
        "invalid access token": "Ongeldig toegangstoken",
        "invalid refresh token": "Ongeldig verversingstoken",
        "no permission to access this project": "Geen toegang tot dit project",
        "Stay Alarm Time": "Verblijfalarmtijd",
        "This function only support sl20 lock.": "Deze functie ondersteunt alleen sl20-slot.",
        "Json marshal error.": "Json-marshal-fout.",
        "Json unmarshal error.": "Json-unmarshal-fout.",
        "Illegal request, not added within valid time.": "Onrechtmatig verzoek, niet binnen geldige tijd toegevoegd.",
        "invalid nvr type": "Ongeldig NVR-type",
        "project is empty": "Project is leeg",
        "project type is invalid": "Projecttype is ongeldig",
        "owner is invalid": "Eigenaar is ongeldig",
        "url is invalid": "URL is ongeldig",
        "password is invalid": "Wachtwoord is ongeldig",
        "building is invalid": "Gebouw is ongeldig",
        "fail to get data": "Mislukt om gegevens te verkrijgen",
        "invalid allow pm view type": "Ongeldig type PM-view toegestaan",
        "Data not exist.": "Gegevens bestaan niet.",
        "cannot find community PrivateKey.": "Kan community-PrivateKey niet vinden.",
        "cannot find single PrivateKey.": "Kan enkele PrivateKey niet vinden.",
        "The third party not exist.": "Derde partij bestaat niet.",
        "{0} and indoor monitors/guard phones": "{0}-app en binnenmonitoren/beheertelefoons",
        "{0} and indoor monitors/guard phones, with phone as backup": "Eerst {0}-app en binnenmonitoren/beheertelefoons, bij geen antwoord vervolgens het telefoonnummer",
        "Indoor monitors/guard phones with {0} as backup": "Eerst binnenmonitoren/beheertelefoons, bij geen antwoord vervolgens {0}-app",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "Eerst binnenmonitoren/beheertelefoons, bij geen antwoord vervolgens {0}-app, en tot slot het telefoonnummer",
        "{0} Intercom Feature": "{0} intercomfunctie",
        "Capture on {0}": "Screenshot op {0} app",
        "{0} Intercom Feature is not activated or has expired.": "{0}-intercomfunctie is niet geactiveerd of verlopen.",
        "fingerprint code must be equal 1620 characters or empty.": "Vingerafdrukcode moet exact 1620 tekens zijn of leeg zijn.",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "Zorg ervoor dat de batterij van het slot boven 40% is voor een succesvolle upgrade.",
        "Automatic Locking Time": "Automatische slottijd",
        "WiFi Keep-Alive": "WiFi Keep-Alive",
        "WiFi Setting": "WiFi-instelling",
        "Connecting the network...": "Netwerk verbinden...",
        "Set successfully!": "Instellen geslaagd!",
        "The offline code can be used even if the lock is not connected to WiFi.": "De offlinecode werkt ook als het slot niet met WiFi verbonden is.",
        "Enabling this feature will increase the lock\'s power consumption.": "Deze functie verhoogt het energieverbruik van het slot.",
        "Each offline code can only be used once.": "Elke offlinecode kan slechts eenmaal worden gebruikt.",
        "Receiver Info": "Informatie ontvanger",
        "log id": "log-id",
        "Create HW SN Config Empty SN.": "Lege SN bij HW SN-configuratie aanmaken.",
        "The SN": "Het serienummer",
        "SN can contain up to 32 characters.": "Serienummer mag maximaal 32 tekens bevatten.",
        "Check HW SN Not Found.": "HW-serienummer niet gevonden.",
        "the end user not found": "Eindgebruiker niet gevonden",
        "Family Call": "Gezinsgesprek",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "Tijdens de upgrade zijn alle slotfuncties tijdelijk niet beschikbaar.",
        "8-digit PIN code starting with \"9\" is invalid!": "Een 8-cijferige PIN die begint met \"9\" is ongeldig!",
        "Lock name length must be between 1 and 50": "Slotnaam moet tussen 1 en 50 tekens lang zijn",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "Het aantal personeelsleden met vaste telefoondienst mag niet hoger zijn dan het aantal personeelsleden met {0} intercomdienst.",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "Het aantal beheerders met vaste telefoondienst mag niet hoger zijn dan het aantal beheerders met {0} intercomdienst.",
        "charge type": "type kosten",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "Het aantal personeelsleden met een vaste lijn mag niet groter zijn dan het aantal met SmartPlus Intercom.",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "Het aantal beheerders met een vaste lijn mag niet groter zijn dan het aantal met SmartPlus Intercom.",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "Een lezer kan niet tegelijkertijd voor Wiegand en RS485 worden geconfigureerd.",
        "parameter error": "parameterfout",
        "community name already exist": "gemeenschapsnaam bestaat al",
        "personnel app without intercom feature number": "personeelsapp zonder intercomfunctie-nummer",
        "check feature billing charge plan new error": "fout bij het controleren van kenmerk factureringsplan",
        "subscription not found": "abonnement niet gevonden",
        "System setting record not found.": "Systeeminstellingenrecord niet gevonden.",
        "Smart home not enabled.": "Slim huis niet ingeschakeld.",
        "the apt call type value is invalid.": "de waarde van het apt-beltype is ongeldig.",
        "the ip call or sip call value is invalid.": "de waarde van ip- of sip-oproep is ongeldig.",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "pinCode moet een getal van 2-8 cijfers zijn, maar mag geen 8-cijferig nummer zijn dat met 9 begint of leeg zijn.",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCard moet uit A-F0-9 zijn en minder dan 16 bits bevatten of leeg zijn.",
        "owner cannot be empty.": "eigenaar mag niet leeg zijn.",
        "creator cannot be empty.": "maker mag niet leeg zijn.",
        "the creator type value is invalid": "de waarde van het makertype is ongeldig",
        "the IsCreateByPm value is invalid": "de waarde van IsCreateByPm is ongeldig",
        "the pinCode already exist": "de pinCode bestaat al",
        "the rfCard already exist": "de rfCard bestaat al",
        "license plate is invalid.": "kenteken is ongeldig.",
        "owner info is invalid.": "eigenaarinformatie is ongeldig.",
        "uhf is invalid.": "uhf is ongeldig.",
        "time control is invalid.": "tijdscontrole is ongeldig.",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "U heeft het maximum van 5 voertuigkentekens bereikt en kunt niet meer toevoegen",
        "the plate already exist": "het kenteken bestaat al",
        "the uhf already exist": "de uhf bestaat al",
        "empty community": "lege gemeenschap",
        "no find license Plate": "kenteken niet gevonden",
        "IDAccess mode must be 0, 1, or 2.": "IDAccess-modus moet 0, 1 of 2 zijn.",
        "Run field is required when mode is 1 or 2.": "Run-veld is vereist wanneer modus 1 of 2 is.",
        "Serial field is required when mode is 2.": "Serienummer-veld is vereist wanneer modus 2 is.",
        "the pin cannot be empty": "de pincode mag niet leeg zijn",
        "the rfCard cannot be empty": "de rfCard mag niet leeg zijn",
        "the IDAccess already exist": "de IDAccess bestaat al",
        "the resident cannot be empty": "de bewoner mag niet leeg zijn",
        "the fingerprint cannot be empty": "de vingerafdruk mag niet leeg zijn",
        "the face cannot be empty": "het gezicht mag niet leeg zijn",
        "not found pin": "pincode niet gevonden",
        "not found rfCard": "rfCard niet gevonden",
        "not found IDAccess": "IDAccess niet gevonden",
        "not found fingerprint": "vingerafdruk niet gevonden",
        "not found face": "gezicht niet gevonden",
        "face pic is invalid.": "gezichtsfoto is ongeldig.",
        "community build and room cannot be empty.": "gemeenschapsgebouw en kamer mogen niet leeg zijn.",
        "device info mac cannot be empty.": "apparaatinfo mac mag niet leeg zijn.",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "plannertype moet 0, 1, 2 zijn of tijdformaat is ongeldig of dataflag niet in 0-127.",
        "MAC address cannot be empty.": "MAC-adres mag niet leeg zijn.",
        "MAC address 0C1105000000 is not allowed.": "MAC-adres 0C1105000000 is niet toegestaan.",
        "MAC address must be 12 hexadecimal characters.": "MAC-adres moet uit 12 hexadecimale tekens bestaan.",
        "Scheduler type value is invalid.": "Plannertype waarde is ongeldig.",
        "parse is fail": "ontleden mislukt",
        "the fingerprint already exist": "de vingerafdruk bestaat al",
        "the licensePlate cannot be empty": "het kenteken mag niet leeg zijn",
        "the licensePlate already exist": "het kenteken bestaat al",
        "idaccess run must be 10 digit number or end with -K.": "idaccess run moet een 10-cijferig getal zijn of eindigen met -K.",
        "idaccess serial must be 9 digit number.": "idaccess-serienummer moet een getal van 9 cijfers zijn.",
        "relay not in 0-15": "relais niet in 0-15",
        "security relay not in 0-3": "beveiligingsrelais niet in 0-3",
        "file name is wrong": "bestandsnaam is verkeerd",
        "access mode specified": "toegangsmodus opgegeven",
        "create community user accessmode failed.": "aanmaken van gemeenschapsgebruikertoegangsmodus mislukt.",
        "delete community user accessmode failed.": "verwijderen van gemeenschapsgebruikertoegangsmodus mislukt.",
        "Cannot delete building because it has associated users.": "Kan gebouw niet verwijderen omdat het gekoppelde gebruikers heeft.",
        "Cannot delete building because it has associated Salto devices.": "Kan het gebouw niet verwijderen omdat het gekoppelde Salto-apparaten heeft.",
        "community building not found": "gemeenschapsgebouw niet gevonden",
        "Invalid Name Display": "Ongeldige naamweergave",
        "The Community does not exist.": "De gemeenschap bestaat niet.",
        "Update CommunityIsInstallerKit Error.": "Fout bij updaten CommunityIsInstallerKit.",
        "Dis Not SupportCommunityCalls Error.": "Agent ondersteunt CommunityCalls niet.",
        "Community Has Special Device, Not Allowed To Delete.": "Gemeenschap heeft speciaal apparaat, verwijderen niet toegestaan.",
        "The project smart home switch must be disabled": "De smart home-schakelaar van het project moet uitgeschakeld zijn",
        "There are ITec Locks in project": "Er zijn ITec-sloten in het project",
        "There are Salto Locks in project": "Er zijn Salto-sloten in het project",
        "There are Dormakaba Locks in project": "Er zijn Dormakaba-sloten in het project",
        "It is rent manager project": "Het is een Rent Manager-project",
        "It is installer account": "Het is een installateursaccount",
        "contact preference type": "contactvoorkeurtype",
        "Floor list is required when not all floors.": "Verdiepinglijst is vereist wanneer niet alle verdiepingen.",
        "Building floors list is required when all buildings.": "Gebouwverdiepingenlijst is vereist bij alle gebouwen.",
        "Indoor monitor name is required.": "Naam van indoor monitor is vereist.",
        "The primary account is not activated.": "Het hoofdaccount is niet geactiveerd.",
        "You can\'t create more family member accounts.": "U kunt geen extra gezinsledenaccounts aanmaken.",
        "community user not found": "gemeenschapsgebruiker niet gevonden",
        "community is empty": "gemeenschap is leeg",
        "the end user not master user": "de eindgebruiker is geen hoofdgebruiker",
        "the end user not member user": "de eindgebruiker is geen lid-gebruiker",
        "The email already exists and cannot be repeated": "Het e-mailadres bestaat al, dubbele invoer niet toegestaan",
        "The mobile Number already exists": "Het mobiele nummer bestaat al",
        "The room number format error.": "Het formaat van het kamernummer is fout.",
        "community not found": "gemeenschap niet gevonden",
        "resident not found": "bewoner niet gevonden",
        "installer not found": "installateur niet gevonden",
        "Operation Failed!": "Operatie mislukt!",
        "You don\'t have operate permission": "U heeft geen bewerkingsrechten",
        "You cannot select Relay and Door at the same time": "U kunt niet gelijktijdig relais en deur selecteren",
        "user don\'t active": "gebruiker niet actief",
        "User has expired": "Gebruiker is verlopen",
        "timestamp must be within 3 minutes of current server time": "tijdstempel moet binnen 3 minuten na de huidige servertijd zijn",
        "cannot find single rf Card.": "één enkele rf Card niet gevonden.",
        "cannot find community rf Card.": "gemeenschap rf Card niet gevonden.",
        "smartLock model": "smartLock-model",
        "the project does not open smart home": "het project heeft smart home niet ingeschakeld",
        "php web server error": "php-webserverfout",
        "Ins not found.": "Ins niet gevonden.",
        "RentManage Unit Not Set.": "RentManage-eenheid niet ingesteld.",
        "add audit log error": "fout bij toevoegen auditlogboek",
        "check building in error": "fout bij controleren van gebouw",
        "Special devices cannot be deleted": "Speciale apparaten kunnen niet verwijderd worden",
        "the email is empty": "e-mailadres is leeg",
        "the email format is incorrect": "e-mailformaat is onjuist",
        "the mobile number is empty": "mobiele nummer is leeg",
        "the mobile number format is incorrect": "mobiele nummerformaat is onjuist",
        "Site not found": "Locatie niet gevonden",
        "User not found": "Gebruiker niet gevonden",
        "invalid time format": "ongeldig tijdformaat",
        "ground floor type": "formaat tussenverdieping",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "Fout in startverdiepingsbereik, geldige waarden zijn -10 tot -1, G0, G1, G2, 1 tot 128.",
        "Building ID must be between 1 and 99.": "Gebouw-ID moet tussen 1 en 99 zijn.",
        "Community building name": "Naam van het gemeenschapsgebouw",
        "Building ID already exists in this community.": "Dit gebouw-ID bestaat al in deze gemeenschap.",
        "building ID": "gebouw-ID",
        "Community building not found.": "Gemeenschapsgebouw niet gevonden.",
        "Cannot delete building because it has associated devices.": "Kan gebouw niet verwijderen wegens gekoppelde apparaten.",
        "project is not valid": "project is ongeldig",
        "Cannot delete building because it has associated salto devices.": "Kan gebouw niet verwijderen wegens gekoppelde Salto-apparaten.",
        "Cannot delete building because it has associated iTec devices.": "Kan gebouw niet verwijderen wegens gekoppelde iTec-apparaten.",
        "Cannot delete building because it has associated dormakaba devices.": "Kan gebouw niet verwijderen wegens gekoppelde Dormakaba-apparaten.",
        "member limit num": "limiet voor aantal leden",
        "Indoor Monitor No Set Error.": "Fout: binnenmonitor niet ingesteld.",
        "The room not has indoor": "De kamer heeft geen binnenunit.",
        "check user in building error": "controleer gebruiker in gebouw fout",
        "The name specified is already in use.": "De opgegeven naam is al in gebruik.",
        "This timeblock overlaps with an existing one. Please adjust it.": "Deze tijdsblok overlapt met een bestaand tijdsblok. Pas het alstublieft aan.",
        "This door status changed. Please try again.": "De status van deze deur is gewijzigd. Probeer het opnieuw.",
        "the lock can\'t bind this community": "Het slot kan deze gemeenschap niet binden.",
        "The custom quantity limit has been exceeded!": "De aangepaste hoeveelheidslimiet is overschreden!",
        "This time span overlaps with an existing one. Please adjust it.": "Deze tijdspanne overlapt met een bestaande. Pas het alstublieft aan.",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "Deze eenmalige planning overlapt met de geldige tijd van een bestaande eenmalige planning. Pas dit alstublieft aan.",
        "Operation Failed. Please try again.": "Operatie mislukt. Probeer het alstublieft opnieuw.",
        "The image is not a front view.": "De afbeelding is geen vooraanzicht.",
        "A mask was detected.": "Er is een mondkapje gedetecteerd.",
        "The image resolution is too low.": "De resolutie van de afbeelding is te laag.",
        "No face was detected.": "Er is geen gezicht gedetecteerd.",
        "The file size is too large.": "Het bestand is te groot.",
        "The face in the image is too large.": "Het gezicht op de afbeelding is te groot.",
        "The face in the image is too small.": "Het gezicht op de afbeelding is te klein.",
        "Multiple faces detected.": "Meerdere gezichten gedetecteerd.",
        "The face is not clear enough.": "Het gezicht is niet duidelijk genoeg.",
        "Face detection failed.": "Gezichtsdetectie mislukt.",
        "Please enter a value between 1 and 9999": "Voer een waarde in tussen 1 en 9999",
        "Please select which input your door sensor is connected to.": "Selecteer alstublieft met welke ingang uw deursensor is verbonden.",
        "Add temp key failed, please try it again": "Tijdelijke sleutel toevoegen mislukt, probeer het opnieuw.",
        "Dis Not Support Dynamic QRCode Error.": "Agent ondersteunt dynamische QR-code niet.",
        "QR code not exist": "QR-code bestaat niet",
        "The temp key has expired.": "De tijdelijke sleutel is verlopen.",
        "The device is not in the office": "Het apparaat is niet op kantoor.",
        "The device is already assigned.": "Het apparaat is al toegewezen.",
        "The device cannot be assigned to any user.": "Het apparaat kan niet aan een gebruiker worden toegewezen.",
        "You cannot select an option with fewer users than the current project members.": "U kunt geen optie selecteren met minder gebruikers dan het huidige aantal projectleden.",
        "File check failed. Please download the latest template and try again.": "Bestandscontrole mislukt. Download het nieuwste sjabloon en probeer het opnieuw.",
        "Dynamic QR Code not active.": "Dynamische QR-code niet actief.",
        "Dynamic QR Code not enable.": "Dynamische QR-code niet ingeschakeld.",
        "{0} not found.": "{0} niet gevonden.",
        "Tier charge plan": "Tariefstructuur per niveau",
        "Feature billing charge plan new": "Functie factureringsplan nieuw",
        "Feature billing gradient charge plan": "Functiefacturering gradiënttariefplan",
        "The exit time cannot be earlier than the entry time.": "De uitrijtijd mag niet eerder zijn dan de inrijtijd.",
        "User Name or Password": "Gebruikersnaam of wachtwoord",
        "You can only link up to 5 sites.": "U kunt maximaal 5 sites koppelen.",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "Deze kentekenplaat is al bij een bewoner geregistreerd en kan niet aan de blokkeerlijst worden toegevoegd.",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "Dit kenteken staat op de zwarte lijst en kan niet als voertuig worden geregistreerd.",
        "Elevator not configured in company access floor.": "Lift is niet geconfigureerd op de toegangsverdieping van het bedrijf.",
        "the device is not in the office": "Het apparaat is niet op kantoor.",
        "A maximum of 1000 data items can be imported": "Er kunnen maximaal 1000 gegevensitems worden geïmporteerd.",
        "Exit time cannot be later than the current time.": "De vertrektijd mag niet later zijn dan de huidige tijd.",
        "You can only import a file at a time in the current parking lot.": "In het huidige parkeerterrein kunt u per keer slechts één bestand importeren.",
        "The license plate is already in the blocklist.": "De kentekenplaat staat al op de blokkeerlijst.",
        "Building name too long.": "Gebouwnaam te lang.",
        "Unlock failed. Permission denied by user.": "Ontgrendelen mislukt. Toestemming geweigerd door de gebruiker.",
        "Please remove the sensor device(s) before disabling this feature.": "Verwijder eerst het/de sensorapparaat/apparaten voordat u deze functie uitschakelt.",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "Bewerking mislukt! De dagelijkse limiet van 15 records is overschreden voor deze gebruiker.",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "Er kunnen maximaal {0} openbare apparaten per project worden toegevoegd. Neem contact op met Akuvox Technical Support via support{'@'}akuvox.com om er meer toe te voegen.",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "Er kunnen maximaal {0} personeelsaccounts per project worden toegevoegd. Neem contact op met Akuvox Technical Support via support{'@'}akuvox.com om er meer toe te voegen.",
        "cancel": "Annuleren",


    }
};
